import getLanguageFromStorage from 'syf-js-utilities/helpers/getLanguageFromStorage';
import { useMainContext } from '../context';
/**
 * Get the current language from the context
 * and compare it with the one in local storage.
 * If they match return the one from context,
 * else return the one from storage.
 */
var useCurrentLanguage = function () {
    var currentLanguage = useMainContext().currentLanguage;
    var cachedLang = getLanguageFromStorage();
    return currentLanguage === cachedLang ? currentLanguage : cachedLang;
};
export default useCurrentLanguage;
//# sourceMappingURL=use-current-language.js.map